import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addUserApi,
  checkUniqueAadhaarNoApi,
  checkUniquePanNoApi,
  checkUniquePassportNoApi,
  checkUniqueUanApi,
  updateProfileApi,
} from "@/apis/usersProfileApis";

import type { CheckUniquiAadharPanPayloadType } from "@/commonTypes/usersProfileTypes";

export const addUserPofile = createAsyncThunk(`add/user`, async (data: any) => {
  const response = await addUserApi(data);
  return response.data;
});

export const updateProfile = createAsyncThunk(
  "update/updateUserProfile",
  async (data: any) => {
    const response = await updateProfileApi(data);
    return response.data;
  }
);

export const checkUniqueAadharAction = createAsyncThunk(
  "userProfile/checkUniqueAadhar",
  async (data: CheckUniquiAadharPanPayloadType) => {
    const response = await checkUniqueAadhaarNoApi(data);
    return response.data;
  }
);

export const checkUniquePanAction = createAsyncThunk(
  "userProfile/checkUniquePan",
  async (data: CheckUniquiAadharPanPayloadType) => {
    const response = await checkUniquePanNoApi(data);
    return response.data;
  }
);

export const checkUniquePassportAction = createAsyncThunk(
  "userProfile/checkUniquePassport",
  async (data: CheckUniquiAadharPanPayloadType) => {
    const response = await checkUniquePassportNoApi(data);
    return response.data;
  }
);

export const checkUniqueUanAction = createAsyncThunk(
  "userProfile/checkUniqueUan",
  async (data: CheckUniquiAadharPanPayloadType) => {
    const response = await checkUniqueUanApi(data);
    return response.data;
  }
);
